import { cn } from "~/lib/utils";

export function SupportBadge({
  menuIsOpen = false,
}: {
  /** When true, lowers z-index so the badge stays behind mobile navigation */
  menuIsOpen?: boolean;
}) {
  return (
    <a
      href={`${import.meta.env.VITE_BASE_URL}/support`}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        "text-xs md:text-base fixed hover:underline hover:cursor-pointer tracking[1px] font-bold top-[calc(100vh/2-20px)] -left-[30px] md:-left-[45px] w-[80px] md:w-[120px] h-[20px] md:h-[30px] bg-black text-white padding-2 -rotate-90 flex items-center justify-center rounded-b-md",
        menuIsOpen ? "z-10" : "z-50",
      )}
    >
      LG<span className="text-primary">24</span>&nbsp;Support
    </a>
  );
}
